module.exports = __webpack_public_path__ + "img/common-name.89b0e949.png";